module.exports = __webpack_public_path__ + "static/media/img4.2dabf053.jpg";